export function Backdrop() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 hidden opacity-50 md:block"
      style={{ background: "var(--color-bg)" }}
    />
  );
}
